<template>
  <PageWrapper>
    <div class="container">
      <div class="row c-justify-center">
        <div class="c-lg:col-10 c-xl:col-8">
          <div class="text-center">
            <h1>{{ t('dear_customer') }}</h1>
            <p v-html="t('there_is_not_even_grain', { email: `<a href='mailto:${t('email')}' rel='noopener'>${t('email')}</a>` })" />
            <BirdError />
          </div>
        </div>
      </div>
      <BaseCategoriesSection
        :title="t('choose_from_our_categories')"
        class="mt-n4 c-mb-6"
      />
    </div>
    <HomeFavoriteProducts />
  </PageWrapper>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import PageWrapper from '@/components/general/BasePageWrapper.vue'
import BaseCategoriesSection from "@/components/general/BaseCategoriesSection.vue";
import HomeFavoriteProducts from '@/components/home/HomeFavoriteProducts.vue'
import useHead from '@/mixins/headManager'

import BirdError from '@/components/svg/birds/BirdError.vue'

const { t } = useI18n()

useHead({
  meta: [
    {
      name: 'robots',
      content: 'noindex, nofollow',
    },
  ],
})
</script>

<i18n>
  {
    "cs": {
    "choose_from_our_categories": "Vybírejte z našich kategorií",
    "dear_customer": "Vážený zákazníku,",
    "email": "info{'@'}mixit.cz",
    "there_is_not_even_grain": "Na této stránce není ani zrníčko, nejspíše vůbec neexistuje. Pokud nemůžete najít, co hledáte, napište nám na {email}, rádi pomůžeme!"
},
    "sk": {
    "choose_from_our_categories": "Vyberte si z našich kategórií",
    "dear_customer": "Vážený zákazník,",
    "email": "info{'@'}mixit.sk",
    "there_is_not_even_grain": "Na tejto stránke nie je ani zrniečko, pravdepodobne vôbec neexistuje. Ak nemôžete nájsť to, čo hľadáte, napíšte nám na {email}, radi Vám pomôžeme!"
},
    "pl": {
    "choose_from_our_categories": "Wybierz jedną z naszych kategorii",
    "dear_customer": "Drogi kliencie,",
    "email": "biuro{'@'}mixit.pl",
    "there_is_not_even_grain": "Na tej stronie nie ma ani jednego ziarenka, prawdopodobnie w ogóle go nie ma. Jeśli nie możesz znaleźć tego, czego szukasz, napisz do nas na adres {email}, chętnie pomożemy!"
},
    "hu": {
    "choose_from_our_categories": "Válogass kategóriáink közül",
    "dear_customer": "Tisztelt Vásárlónk,",
    "email": "info{'@'}mixit.hu",
    "there_is_not_even_grain": "Ezen az oldalon még egy gabonaszem sincs, valószínűleg nem is létezik. Ha nem találja, amit keres, írjon nekünk a következő címre: {email} , szívesen segítünk!"
},
    "de": {
    "choose_from_our_categories": "Wähle aus unseren Kategorien",
    "dear_customer": "Lieber Kunde,",
    "email": "info{'@'}mixit.de",
    "there_is_not_even_grain": "Offenbar existiert diese Seite nicht.\nBrauchst du Unterstützung? Schreib uns an {email}, wir helfen dir gerne weiter!"
},
    "at": {
    "choose_from_our_categories": "Wähle aus unseren Kategorien",
    "dear_customer": "Lieber Kunde,",
    "email": "info{'@'}mixit.de",
    "there_is_not_even_grain": "Offenbar existiert diese Seite nicht.\nBrauchst du Unterstützung? Schreib uns an {email}, wir helfen dir gerne weiter!"
},
    "ro": {
    "choose_from_our_categories": "Alegeți din categoriile noastre",
    "dear_customer": "Stimate client,",
    "email": "info{'@'}mixit.ro",
    "there_is_not_even_grain": "Pe această pagină nu există nici măcar un bob de grâu, probabil că nu există deloc. Dacă nu găsiți ceea ce căutați, scrieți-ne la {email}, și vă vom ajuta cu plăcere!"
},
    "fr": {
    "choose_from_our_categories": "Choisissez parmi nos catégories",
    "dear_customer": "Cher client,",
    "email": "info{'@'}mixit.fr",
    "there_is_not_even_grain": "Sur cette page, il n’y a pas le moindre grain, elle n’existe probablement pas du tout. Si vous ne trouvez pas votre bonheur, écrivez-nous à {email}, nous vous aiderons avec plaisir !"
},
    "it": {
    "choose_from_our_categories": "Scegli tra le nostre categorie",
    "dear_customer": "Gentile cliente,",
    "email": "info{'@'} mixit.it",
    "there_is_not_even_grain": "Su questa pagina non c'è nemmeno un granello, probabilmente non esiste affatto. Se non riesci a trovare quello che cerchi, scrivici all'indirizzo {email}, saremo lieti di aiutarti!"
}
  }
</i18n>
